module.exports = __webpack_public_path__ + "static/media/SWSCRC6-49.854a27bd.mp3";